export default __webpack_public_path__ + "static/media/3.2bde0ff1.png";